"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPProtectionState = exports.CommercialisationState = exports.CaseForm = void 0;
var CaseForm;
(function (CaseForm) {
    // Commercialisation Forms
    CaseForm["COMMERCE_HYPOTHESIS_FORM"] = "COMMERCE_HYPOTHESIS_FORM";
    CaseForm["COMMERCE_GATE_C1_FORM"] = "COMMERCE_GATE_C1_FORM";
    CaseForm["COMMERCE_GATE_SO1_FORM"] = "COMMERCE_GATE_SO1_FORM";
    // IP Forms
    CaseForm["IP_PROTECTION_GATE_P1_FORM"] = "IP_PROTECTION_GATE_P1_FORM";
    CaseForm["IP_PROTECTION_GATE_P2_FORM"] = "IP_PROTECTION_GATE_P2_FORM";
    CaseForm["IP_PROTECTION_GATE_P3_FORM"] = "IP_PROTECTION_GATE_P3_FORM";
})(CaseForm || (exports.CaseForm = CaseForm = {}));
var CommercialisationState;
(function (CommercialisationState) {
    CommercialisationState["GATE_C1"] = "GATE_C1";
    CommercialisationState["GATE_SO1"] = "GATE_SO1";
    CommercialisationState["SPIN_OUT"] = "SPIN_OUT";
    CommercialisationState["LICENSE_TRACK"] = "LICENSE_TRACK";
    CommercialisationState["NO_COMMERCIALISATION"] = "NO_COMMERCIALISATION";
})(CommercialisationState || (exports.CommercialisationState = CommercialisationState = {}));
var IPProtectionState;
(function (IPProtectionState) {
    IPProtectionState["IP_INACTIVE"] = "IP_INACTIVE";
    IPProtectionState["GATE_P1"] = "GATE_P1";
    IPProtectionState["IP_PRIORITY"] = "IP_PRIORITY";
    IPProtectionState["GATE_P2"] = "GATE_P2";
    IPProtectionState["NIPMO"] = "NIPMO";
    IPProtectionState["GATE_P3"] = "GATE_P3";
    IPProtectionState["NATIONAL"] = "NATIONAL";
    IPProtectionState["INVENTORS"] = "INVENTORS";
    IPProtectionState["ABANDONED"] = "ABANDONED";
})(IPProtectionState || (exports.IPProtectionState = IPProtectionState = {}));
